import { motion } from "framer-motion";
import { Dumbbell, Leaf, Wheat, Droplet, Palette, ShieldCheck, Flame } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { USP_ITEMS } from "@/lib/constants";

const ICONS = { Dumbbell, Leaf, Wheat, Droplet, Palette, ShieldCheck, Flame };

export default function USPSection() {
  return (
    <section className="relative overflow-hidden bg-forest py-24 lg:py-28" data-testid="usp-section">
      <div className="absolute inset-0 grain opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Overline>Why It's Different</Overline>
          <h2 className="mt-3 max-w-2xl font-display text-5xl leading-none tracking-tight text-cream sm:text-6xl lg:text-7xl">
            SNACKING, <span className="text-gold-gradient">DONE RIGHT</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-7">
          {USP_ITEMS.map((u, i) => {
            const Icon = ICONS[u.icon];
            return (
              <motion.div key={u.label}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ delay: i * 0.07, duration: 0.6 }}
                whileHover={{ y: -6 }}
                className="group rounded-2xl border border-white/10 bg-black/30 p-5 text-center transition-colors hover:border-gold/50"
                data-testid={`usp-${i}`}>
                <div className="mx-auto grid h-14 w-14 place-items-center rounded-full gold-gradient text-black transition-transform group-hover:scale-110 group-hover:rotate-6">
                  <Icon size={24} />
                </div>
                <h3 className="mt-4 font-oswald text-sm uppercase leading-tight tracking-wide text-cream">{u.label}</h3>
                <p className="mt-1 text-[11px] text-white/45">{u.desc}</p>
              </motion.div>
            );
          })}
        </div>
        <p className="mt-8 text-center text-xs text-white/30">
          Enjoy as part of a balanced diet. Nutrition values are approximate.
        </p>
      </div>
    </section>
  );
}
